import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { requiresBanner, setConsent } from '../utils/consent';
import './ConsentBanner.css';

/**
 * Cookie / consent banner shown only when Consent Mode v2 reports that the
 * visitor is in a region where defaults are denied (EEA / UK) and no decision
 * has been recorded yet. Outside those regions analytics defaults to granted
 * and the banner stays hidden.
 */
const ConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(requiresBanner());
  }, []);

  if (!visible) return null;

  const acceptAll = () => {
    setConsent({ analytics: true, ads: true });
    setVisible(false);
  };

  const rejectAll = () => {
    setConsent({ analytics: false, ads: false });
    setVisible(false);
  };

  const acceptAnalyticsOnly = () => {
    setConsent({ analytics: true, ads: false });
    setVisible(false);
  };

  return (
    <div className="consent-banner" role="dialog" aria-live="polite" aria-label="Cookie consent">
      <div className="consent-banner-inner">
        <div className="consent-banner-text">
          <strong>We use cookies.</strong>{' '}
          We use cookies and similar technologies to provide the FreshFitLab service, measure usage,
          and (with your permission) personalize ads. See our{' '}
          <Link to="/privacy">Privacy Policy</Link> for details.
        </div>
        <div className="consent-banner-actions">
          <button type="button" className="consent-btn consent-btn-secondary" onClick={rejectAll}>
            Reject all
          </button>
          <button type="button" className="consent-btn consent-btn-secondary" onClick={acceptAnalyticsOnly}>
            Analytics only
          </button>
          <button type="button" className="consent-btn consent-btn-primary" onClick={acceptAll}>
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;
